import PDFIcon from './component'

export default PDFIcon
